module.exports = __webpack_public_path__ + "static/media/aquecedor1.2a01c305.png";